module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.ttf?adec7d6f310bc577f05e8fe06a5daccf";